/* eslint-disable react/no-danger */
import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { createMarkup } from 'utilities/utils';

// // Styles // //
const styles = {
    '&.MuiDialogTitle-root': {
        margin: 0,
        padding: '0.8em',
    },
    '&.MuiIconButton-root': {
        position: 'absolute',
        right: '0.3em',
        top: '0.3em',
    },
    '&.MuiDialogActions-root': {
        margin: 0,
        padding: '0.5em',
    },
    '&.MuiDialogContent-root': {
        padding: '1em',
    },
};

const DialogTitle = (props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography sx={styles} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    sx={styles}
                    onClick={onClose}
                    size="large"
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
};

const AboutTheData = ({ aboutText }) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Typography onClick={handleClickOpen}>About These Data</Typography>
            <Dialog
                onClose={handleClose}
                aria-labelledby="about-data-dialogue"
                open={open}
                sx={styles}
                hideBackdrop
            >
                <DialogTitle id="about-data-title" onClose={handleClose}>
                    About These Data
                </DialogTitle>
                <MuiDialogContent dividers sx={styles}>
                    <Typography gutterBottom>
                        <span
                            dangerouslySetInnerHTML={createMarkup(aboutText)}
                        />
                    </Typography>
                </MuiDialogContent>
                <MuiDialogActions sx={styles}>
                    <Button autoFocus onClick={handleClose} color="primary">
                        Close
                    </Button>
                </MuiDialogActions>
            </Dialog>
        </div>
    );
};

export default AboutTheData;
